import React from 'react'
import TrialOfferRedesigned from './TrialOfferRedesigned'

/**
 * Plans step of the signup flow.
 *
 * The redesign won the `signup-trial-offer-redesign` experiment (stopped 2026-09-15)
 * and is now the only page, so the step no longer waits on PostHog. Visitors whose
 * flags are blocked or slow used to fall back to the old page after 2.5s; they now
 * get the redesign like everyone else.
 */
const TrialOffer = ({ next }: { next: () => void }) => <TrialOfferRedesigned next={next} />

export default TrialOffer
